import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'
import { unstyledButtonCss, roundButtonCss } from './sharedStyles'

export const Header = styled.header`
  padding: 20px 0;
`
export const LogoImage = styled.img`
  height: 35px;
  max-width: 100%;
  width: auto;
`

export const Container = styled.div`
  padding: 0 15px;
  margin: auto;

  @media (min-width: 768px) {
    max-width: 720px;
  }
  @media (min-width: 1200px) {
    max-width: 1140px;
  }
`

Container.Row = styled.div`
  margin-left: -15px;
  margin-right: -15px;
  display: flex;
  justify-content: center;
  flex-direction: ${props => (props.reverseMobile ? 'column-reverse' : 'column')};

  @media (min-width: 1200px) {
    flex-direction: row;
  }
`

Container.Column = styled.div`
  flex: 1 0 0%;
  padding: 0 15px;
  display: ${props => (props.hidden ? 'none' : 'block')};
  margin-bottom: 15px;

  @media (min-width: 1200px) {
    width: ${props => (props.halfColumnLarge ? '50%' : 'initial')};
  }
`
export const Title = styled.h1`
  margin: 0;
  margin-bottom: 15px;
`

export const SubTitle = styled.h2`
  margin: 0;
  margin-bottom: 15px;
`

export const List = styled.ul`
  padding: 0;
  list-style: none;
`

List.Item = styled.li`
  display: flex;
  margin-bottom: 20px;
`
List.ItemBullet = styled.strong`
  padding-right: 10px;
`

List.ItemText = styled.p`
  margin: 0;
`

export const RoundLink = styled(Link)`
  ${roundButtonCss}
`

export const RoundButton = styled.button`
  ${roundButtonCss}
`

export const TextBox = styled.p`
  padding: 5px 10px;
  border-radius: 15px;
  border: 1px solid #222;
  margin: 0;
`

export const JustifySpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${props => props.mb || 0}px;
`

export const UnstyledRouterLink = styled(Link)`
  ${unstyledButtonCss}
  margin-bottom: ${props => props.mb || 0}px;
`

export const UnstyledButton = styled.button`
  ${unstyledButtonCss}
`

const modalStatus = {
  close: css`
    display: none;
    opacity: 0;
    z-index: 0;
  `,
  toggle: css`
    display: block;
    opacity: 0;
    z-index: 1;
  `,
  open: css`
    display: block;
    opacity: 1;
    z-index: 1;
  `
}

const setModalStatus = props => modalStatus[props.status]

export const Modal = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  transition: 0.4s ease-in-out;
  z-index: ${props => (props.isOpen ? 1 : 0)};

  ${setModalStatus}
`

Modal.Wrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
`

Modal.Body = styled.div`
  padding: 20px;
  background-color: white;
  border-radius: 10px;
  max-width: 500px;
`

Modal.Text = styled.p`
  margin: 0;
  margin-bottom: 15px;
`
Modal.TextArea = styled.textarea`
  width: 100%;
  outline: none;
  border-radius: 4px;
  border-color: #dadada;
  margin-bottom: 15px;
  padding: 10px;
`
